import { Link } from "react-router-dom";
import { Reveal } from "@/components/common/Reveal";

export const CTASection = () => (
  <section data-testid="home-cta-section" className="bg-brand-purple py-24 text-white">
    <div className="mx-auto max-w-4xl px-6 text-center lg:px-12">
      <Reveal>
        <h2 className="font-heading text-4xl uppercase sm:text-6xl">Watch Live</h2>
        <p className="mx-auto mt-4 max-w-xl text-white/80">
          Follow live coverage across Kick, Twitch, YouTube and TikTok — pick the platform that works for you.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/live"
            data-testid="cta-watch-live-btn"
            className="bg-brand-black px-8 py-4 font-subheading text-sm font-semibold uppercase tracking-wide transition-colors hover:bg-white hover:text-brand-black"
          >
            Watch Live
          </Link>
          <Link
            to="/contact"
            data-testid="cta-contact-btn"
            className="border border-white px-8 py-4 font-subheading text-sm font-semibold uppercase tracking-wide transition-colors hover:bg-white hover:text-brand-purple"
          >
            Get In Touch
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
